import React, { useEffect } from "react";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { Button, Dragger, Loader, NoData } from "oned";
import { ProblemLevel, StepType } from "@common/enums/base";
import './index.less';
import SvgImage from "../svgImage";
import moment from "moment";
import { isEmpty } from "lodash-es";
import PubSub from "@common/utils/pubsub";
import { RecallCheckBusiness } from "@business/newCreateRequest/stepsItems/recallCheck";
import HowToVideo from "../howToVideo";
import { isMobile } from "@common/utils";
import { RecallCertifierType } from "@common/enums/availability";
var DifferentIssue = ProblemLevel.DifferentIssue;
var RecallCheckList = inject(RecallCheckBusiness)(observer(function (props) {
    var jump = props.jump, setLevel = props.setLevel, setOriginWO = props.setOriginWO, recallWOList = props.recallWOList, computeRecallWOList = props.computeRecallWOList, toggleWOAttachmentShow = props.toggleWOAttachmentShow, screenWidth = props.screenWidth, screenLimit = props.screenLimit, recallWOsLoading = props.recallWOsLoading, commonStoreSetParam = props.commonStoreSetParam, isRecallCheck = props.isRecallCheck, clearAfterStepData = props.clearAfterStepData, revertProblemData = props.revertProblemData, backUpWO = props.backUpWO, videoURL = props.videoURL, setHowToVideoVisible = props.setHowToVideoVisible, howToVideoVisible = props.howToVideoVisible, setAvailabilityParam = props.setAvailabilityParam;
    var handleJump = function () {
        if (isRecallCheck) {
            clearAfterStepData();
            revertProblemData(backUpWO);
        }
        setAvailabilityParam("recallCertifierType", RecallCertifierType.OMManualCertifed);
        setAvailabilityParam("certifiedRecallWoId", null);
        commonStoreSetParam('isRecallCheck', false);
        jump(StepType.Detail);
        setLevel(DifferentIssue);
    };
    var handleOriginWO = function (wo) {
        setLevel(ProblemLevel.RecallOriginWO);
        setOriginWO(wo);
        jump(StepType.Detail);
    };
    var handleScreenWidth = function () {
        var setScreenWidth = props.setScreenWidth;
        var zoom = document.documentElement.clientWidth;
        setScreenWidth(zoom);
    };
    useEffect(function () {
        scrollTop();
        handleScreenWidth();
        window.addEventListener('resize', handleScreenWidth);
    }, []);
    var scrollTop = function () {
        PubSub.notify('scrollto', 0);
    };
    useEffect(function () {
        computeRecallWOList(recallWOList);
    }, [screenWidth]);
    var handleDifferentIssue = function () {
        if (videoURL) {
            handleVideoURL();
        }
        else {
            handleJump();
        }
    };
    var handleVideoURL = function () {
        if (isMobile) {
            setLevel(ProblemLevel.HowToVideo);
        }
        else {
            setHowToVideoVisible(true);
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Loader, { page: true, visible: recallWOsLoading }),
        React.createElement("div", { className: "recall-check" },
            React.createElement("div", { className: "dsm-card" },
                React.createElement("div", { className: "dsm-card-body" },
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col-12' },
                            React.createElement("h2", { className: 'problem-title' },
                                React.createElement("b", null, "Recall check"))),
                        React.createElement("div", { className: "col-12 text-mobile-adapt f16" }, "Our records show that a technician has been out here recently to fix a similar issue."),
                        React.createElement("div", { className: "col-12 text-mobile-adapt f16 mt-1" }, "We will contact you if we have further questions."),
                        React.createElement("div", { className: "col-12 mt-4" },
                            React.createElement("b", { className: "f24" }, "Is your request related to one of the past request(s)?"))))),
            !isEmpty(recallWOList) && recallWOList.map(function (wo) { return (React.createElement(RecallWOItem, { wo: wo, handleOriginWO: handleOriginWO, toggleWOAttachmentShow: toggleWOAttachmentShow, screenLimit: screenLimit })); }),
            isEmpty(recallWOList) && React.createElement("div", { className: "dsm-card mt-3" },
                React.createElement("div", { className: "dsm-card-body" },
                    React.createElement(NoData, null))),
            React.createElement("div", { className: "mt-3" },
                React.createElement("div", { className: "recall-submit" },
                    React.createElement(Button, { type: "secondary", block: true, className: "dsm-btn dsm-btn-secondary dsm-btn-block f16", onClick: handleDifferentIssue }, "No, I have a different issue")),
                React.createElement("div", { className: "recall-m-submit" },
                    React.createElement(Button, { type: "secondary", block: true, className: "dsm-btn dsm-btn-primary dsm-btn-block f16", onClick: handleDifferentIssue }, "No, I have a different issue")))),
        howToVideoVisible && React.createElement(HowToVideo, { thenAction: handleJump }));
}));
var RecallWOItem = function (props) {
    var wo = props.wo, handleOriginWO = props.handleOriginWO, toggleWOAttachmentShow = props.toggleWOAttachmentShow, screenLimit = props.screenLimit;
    return React.createElement("div", { className: "dsm-card recall-item mt-3" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-6 col-sm-12 d-flex item-align item-pl" },
                wo.serviceCombinationAliasId ?
                    React.createElement(SvgImage, { iconUrl: wo.serviceCombinationAlias.serviceCodeIconUrl }) :
                    React.createElement(SvgImage, { iconUrl: '' }),
                React.createElement("div", { className: "pl-3" },
                    React.createElement("b", { className: "f16" }, wo.aliasOrServiceComboName),
                    React.createElement("br", null),
                    React.createElement("b", { className: "f16" },
                        "WO #",
                        wo.woId),
                    React.createElement("p", null,
                        "Technician on-site ",
                        moment(wo.completeDate).format('MM/DD/YYYY')))),
            React.createElement("div", { className: "col-md-6 recall-item-top-btn d-flex align-items-center justify-content-center item-pr" },
                React.createElement(Button, { type: "primary", onClick: function () { return handleOriginWO(wo); }, className: "dsm-btn dsm-btn-primary dsm-btn-normal dsm-btn-block f14" }, "Yes, this is related"))),
        React.createElement("div", { className: "bt-divider" }),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-6 col-sm-12 item-pl" },
                React.createElement("div", null,
                    React.createElement("b", { className: "f16" }, "Description")),
                React.createElement("div", { className: "f14 mt-2" }, wo.additionalDetail ? wo.additionalDetail : 'No description...')),
            React.createElement("div", { className: "col-md-6 col-sm-12 item-pr l-divider" },
                React.createElement("div", null,
                    React.createElement("b", { className: "f16" }, "Attachments")),
                wo.attachments.length === 0 && React.createElement("div", { className: "f14 mt-2" }, "No attachments..."),
                wo.attachments.length > 0 && React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "duplicate-check-photo-dragger mt-2" },
                        React.createElement(Dragger, { fileList: wo.tempAttachments, isOnlyView: true, showRemove: false, onUpload: null })),
                    wo.attachments.length > screenLimit && React.createElement("div", { className: "attach-more dsm-btn-secondary d-flex justify-content-center" },
                        React.createElement("div", { className: "d-flex align-items-center", onClick: function () { return toggleWOAttachmentShow(wo, !wo.attachmentShowAll); } }, !wo.attachmentShowAll ?
                            React.createElement(React.Fragment, null,
                                React.createElement("span", null, "See all attachments"),
                                " ",
                                React.createElement("span", { className: "attach-badge" }, wo.attachments.length)) :
                            React.createElement("span", { className: "px-5 py-2" }, "Hide")))))),
        React.createElement("div", { className: "recall-item-m-btn" },
            React.createElement("div", { className: "dsm-btn-secondary", onClick: function () { return handleOriginWO(wo); } }, "Yes, this is related")));
};
export default RecallCheckList;
